<script setup lang="ts">
import { PV } from "@/widgets";
import Icon from "~icons/ic/baseline-delete";

defineEmits<{
    click: [];
}>();
</script>

<template>
    <PV.Button v-tooltip.left="'Buang'" class="p-0!" link @click="$emit('click')">
        <Icon class="bg-red-400 text-white rounded-sm p-0.5 hover:cursor-pointer" />
    </PV.Button>
</template>
